function setCookie(name, value, maxAge = 0) {
  document.cookie = name + "=" + value + ";Max-Age=" + maxAge + ";path=/";
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }

  return undefined;
}

export function useCookie() {
  return {
    setCookie,
    getCookie,
  };
}
